export const pathnameSelector = state => {
  const location = state.routing.locationBeforeTransitions || window.location;
  return (location === null || location === void 0 ? void 0 : location.pathname) || '';
};